// The two rules the permissions table needs, kept out of the component so they
// can be tested without a DOM (frontend/bi CLAUDE.md).
//
// Both MIRROR a server rule rather than inventing one. The refusal is the
// permission: `bi_permissions.py` rejects an edit to your own row with a 403 and
// nothing here can make that edit succeed. What this module buys is that the row
// says so BEFORE the click, instead of after a round trip that reads as a bug.
import type { GrantRow } from "@bi/shared/types";

/** Is this row the signed-in person's own?
 *
 *  Case- and whitespace-insensitive, because the server's check is
 *  (`body.email.strip().lower() == employee.email.strip().lower()`) and a UI
 *  that compared more strictly would offer a control the server then refuses.
 *  An unknown viewer (identity still loading) owns no row: `false` for an empty
 *  `mine` keeps the table readable while it resolves, and the server is still
 *  the gate if a click lands in that window.
 */
export function isSelfGrant(rowEmail: string, mine: string): boolean {
  const a = rowEmail.trim().toLowerCase();
  const b = mine.trim().toLowerCase();
  return a !== "" && a === b;
}

/** Holders in a stable order: `full` first, then alphabetical.
 *
 *  Sorted by LEVEL before name because the question this page is opened to
 *  answer is "who can spend", and `full` is the level that can start a tagging
 *  run. A plain alphabetical list buries that answer among the readers.
 */
export function sortGrants(rows: readonly GrantRow[]): GrantRow[] {
  return [...rows].sort((x, y) => {
    if (x.access !== y.access) return x.access === "full" ? -1 : 1;
    return x.email.localeCompare(y.email);
  });
}
